import { common } from './common';
import { components } from './components';
import { documents } from './documents';
import { emails } from './emails';
import { errors } from './errors';
import { hlreImport } from './hlre-import';
import { notices } from './notices';
import { pages } from './pages';
import { permissions } from './permissions';
import { portal } from './portal';

/**
 * Canonical German dictionary. Its TypeScript shape is the upper bound for
 * every other locale via `Messages = typeof de`; missing or differently-shaped
 * keys in any other locale fail `tsc`.
 */
export const de = {
  common,
  components,
  documents,
  emails,
  errors,
  hlreImport,
  notices,
  pages,
  permissions,
  portal,
} as const;
